/**
 * Created by jmmartinez on 02/04/2026
 * Adaptado para mostrar tildes y caracteres especiales correctamente
 */

import React from "react";
import PropTypes from "prop-types";
import { Editor } from "@tinymce/tinymce-react";

// Función auxiliar para decodificar entidades HTML
function decodeHtmlEntities(str) {
    if (!str) return "";
    const txt = document.createElement("textarea");
    txt.innerHTML = str;
    return txt.value;
}

class HTMLEditorTinyMCE extends React.Component {

    handleChange = (content) => {
        const { onChange } = this.props;
        onChange && onChange(content);
    };

    render() {
        const { texto, height, backgroundColor } = this.props;
        const textoDecodificado = decodeHtmlEntities(texto);

        return (
            <div style={{ backgroundColor }}>
                <Editor
                    apiKey="3tizvbcuhhgt6c4sfirmn5q71ekzjwvqkypk0ba934b82egw"
                    value={textoDecodificado || ""}
                    onEditorChange={this.handleChange}
                    init={{
                        height: height || 300,
                        menubar: false,

                        plugins: [
                            "lists",
                            "link",
                            "image",
                            "table",
                            "code"
                        ],

                        toolbar:
                            "undo redo | bold italic underline | " +
                            "forecolor backcolor | " +
                            "alignleft aligncenter alignright | " +
                            "bullist numlist | removeformat | code",

                        valid_styles: {
                            "*": "color,background-color,font-size,font-weight,text-decoration"
                        },

                        color_map: [
                            "FF0000", "Rojo",
                            "00FF00", "Verde",
                            "0000FF", "Azul",
                            "FFFF00", "Amarillo",
                            "FFA500", "Naranja",
                            "800080", "Morado"
                        ],

                        forced_root_block: "p",

                        // 🔹 Contenido con soporte completo de UTF-8
                        content_style: `
              body { font-family: Arial; font-size: 14px; }
              p, span { white-space: pre-wrap; }
            `
                    }}
                />
            </div>
        );
    }
}

HTMLEditorTinyMCE.propTypes = {
    texto: PropTypes.string,
    onChange: PropTypes.func,
    height: PropTypes.number,
    backgroundColor: PropTypes.string,
};

export default HTMLEditorTinyMCE;